import React, { lazy } from 'react';
import { UploadValidationListing } from '@contract-root/admin-react/src/containers/SystemAdminModule/UOMModule/UploadValidationListing';

const UOMListing = lazy(() =>
  import(
    '@contract-root/admin-react/src/containers/SystemAdminModule/UOMModule/UOMListing'
  ).then(module => ({
    default: module.UOMListing,
  })),
);

const uomRoutes = [
  {
    props: { exact: true, path: '/system-admin/general-settings/uom' },
    component: <UOMListing software="Site" />,
  },
  {
    props: {
      exact: true,
      path: '/system-admin/general-settings/uom/validation',
    },
    component: <UploadValidationListing software="Site" />,
  },
];

export default uomRoutes;
